export const enum Language {
  SC = "sc",
  TC = "tc",
  EN = "en",
}
